import { Form, Formik } from 'formik';
import * as Yup from "yup";
import { Box } from '@mui/material';
import { ROLES } from '../../utils/appRoles';
import axios from '../../utils/axios';
import FormGroup from '../shared/containers/FormGroup';
import Input from '../shared/formInput/Input';
import SelectInput from '../shared/formInput/SelectInput';
import PrimaryButton from '../shared/buttons/PrimaryButton';
import { useEffect, useState } from 'react';
import { handleExcludedFields } from '../../utils/form';
import SwitchInput from '../shared/formInput/SwitchInput';
import {useNotifications} from 'reapop';

const UpdateUserForm = ({submitButtonChildren, dataUrl}) => {
    const {notify} = useNotifications();
    const excludeFields = ["created_at", "last_login"]
    const [initialValues, setInitialValues] = useState(null)
    const formValues = {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        type: '',
        title: '',
        is_active: true
    };



    useEffect(() => {
        (async () => {
            try {
                const response = await axios.get(`user/${dataUrl.id}`);
                const data = handleExcludedFields(response.data, excludeFields);
                if(data.phone_number == null) {
                    data.phone_number = '';
                }
                setInitialValues(data);
            } catch (error) {
                // console.error(error.message);
                setInitialValues(formValues);
            }

        })()
    }, []);

    const onSubmit = async (values, {resetForm, setErrors, setSubmitting, setDirty}) => {
        try {
            await axios.patch(`user/${dataUrl.id}`, values);
            // keep the values after submission and dirty to false
            resetForm({values});
            notify('Utilisateur modifié avec succès', 'info', {dismissAfter: 5000}); 
        } catch (error) {
            setErrors({createError: error.message})
            // console.error(error)
        }
    };

    const validationSchema = Yup.object({
        email: Yup.string()
            .required("champ requis")
            .email("format: utilisateur@domaine.fr"),
        first_name: Yup.string()
            .required("champ requis"),
        type: Yup.string()
            .required("champ requis"),
        last_name: Yup.string()
            .required("champ requis"),
        phone_number: Yup.string()
            .matches(/^\d{10}$|^$/, { message: "Format: 0655443322", excludeEmptyString: true })
            // .required("champ requis"),
    });

    const formStyle = {
        width: "fit-content",
        margin: "2em auto 0"
    };

    return (initialValues &&
        <Formik {...{ initialValues, onSubmit, validationSchema, enableReinitialize:true }}>
            {({errors, isValid, dirty}) => (
                <Box sx={formStyle}>
                    {errors.createError && <p>{errors.createError}</p>}
                    <Form autoComplete="off">
                        <FormGroup multi>
                            <Input
                                {...{
                                    name: "first_name",
                                    label: "Prénom",
                                }}
                            />
                            <Input
                                {...{
                                    name: "last_name",
                                    label: "Nom",
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Input
                                {...{
                                    name: "email",
                                    label: "Email",
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Input 
                                {...{
                                    name: "phone_number",
                                    label: "Téléphone",
                                    required: false,
                                    helperText: "Télephone, format: 0655443322"
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <SelectInput {...{
                                name: "type",
                                label: "Role",
                                options: ROLES,
                            }}/>
                        </FormGroup>
                        <FormGroup>
                            <Input 
                                {...{
                                    name: "title",
                                    label: "Poste",
                                    required: false
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <SwitchInput
                                {...{
                                    name: "is_active",
                                    label: "utilisateur actif",
                                }}
                            />
                        </FormGroup>
                        <PrimaryButton type="submit" disabled={!isValid || !dirty}>
                            {submitButtonChildren}
                        </PrimaryButton>
                    </Form>
                </Box>
            )}
        </Formik>
    );
}

export default UpdateUserForm;
